import { ApolloError } from "@apollo/client";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { Button, Alert, Col, Form, FormFeedback, FormGroup, Input, Label, Row } from "reactstrap";
import { ISearchIndividualInput } from "../../../types/individual";
import { IOrgLight } from "../../../types/org";
import { normalizeApostrophes, validEmail } from "../../../utils/commons";
import { SearchIcon } from "../../common/icons";
import TopOrganizationTypeahead from "../../common/typeahead/top-organization-typeahead";

type SearchIndividualFormProp={
  loading:boolean
  error:ApolloError | undefined
  onSearch:(input:ISearchIndividualInput,isValid: boolean)=>void
  onChange:()=>void
}

export type SearchIndividualFormRef = {
  getInput:() => ISearchIndividualInput;
};

const SearchIndividualForm = forwardRef<SearchIndividualFormRef, SearchIndividualFormProp>((props, ref) => {
  const { loading,error,onSearch,onChange} = props;
  const [input,setInput] = useState<ISearchIndividualInput>({orgId:0,firstName:'',lastName:'',email:''});
  const [valid,setValid] = useState(true);
  const [warning, setWarning] = useState('');
  const [errors, setErrors] = useState({org:'',email:'',firstname:'',lastname:''});
  useEffect(()=>{
    setValid(!errors.org&&!errors.email&&!errors.firstname&&!errors.lastname)
    //console.log("errors:",errors)
  },[errors])

  const getInput = () =>{
    return input;
  }
  useImperativeHandle(ref, () => ({
    getInput
  }));

  const onFirstNameChange = (event:any) => {
    let correctedFirstName = normalizeApostrophes(event.target.value);
    setInput({...input,firstName:correctedFirstName.trim()})
    setErrors({...errors,firstname:''})
    onChange();
  }

  const onLastnameChange = (event:any) => {
    let correctedLastName = normalizeApostrophes(event.target.value);
    setInput({...input,lastName:correctedLastName.trim()})
    setErrors({...errors,lastname:''})
    onChange();
  }

  const onEmailChange = (event:any) => {
    setInput({...input,email:event.target.value.trim()})
    setErrors({...errors,email:''})
    onChange();
  }

  const handleReset = () => {
    clear();
  };

  const clear = () => {
    onChange();
    setValid(true)
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    clear();
    if (input.email&&!validEmail(input.email)) {
        errors.email = "Wrong email";
    }

    setErrors({...errors});

    if(!errors.org && !errors.email && !errors.firstname && !errors.lastname){

        onSearch(input,!!input.email || !!input.firstName || !!input.lastName);
    }

  }

  const orgSelectHandle = (org: IOrgLight | undefined) => {
    const orgId = org?.id || 0;
    setInput((prevInput) => ({ ...prevInput, orgId }));
    setErrors((prevErrors) => ({ ...prevErrors, org: '' }));
    //setInput({...input,orgId:org?.id||0})
    onChange();
  }

  return (
    <>
    <Form onSubmit={handleSubmit} onReset={handleReset}>
      <Row>
        <Col md={6}>
          <FormGroup row>
            <Label for="orgId" sm={4}>
              Under Top Level:
            </Label>
            <Col sm={8}>
              {/*<Input id="orgId" name="orgId" type="select" onChange={(event)=>onOrgChange(event)}>
                <option value="0">All</option>
                {data?.allRootOrgs?.map(item =>
                  <option key={item.id} value={item.id} title={item.orgName}>{item.orgName}</option>
                )}
              </Input>*/}
              <TopOrganizationTypeahead elementId="top-org" orgSelectHandle={orgSelectHandle} validate={(error)=>errors.org=error}/>
            </Col>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <FormGroup row>
            <Label for="firstName" sm={4}>First Name:</Label>
            <Col sm={8}>
              <Input id="firstName" name="firstName" placeholder="Enter an Individual's first name " invalid={!!errors.firstname} onChange={(event)=>onFirstNameChange(event)}/>
              <FormFeedback>{errors.firstname}</FormFeedback>
            </Col>
          </FormGroup>
        </Col>
        <Col md={6}>
          <FormGroup row>
            <Label for="lastName" sm={4}>Last Name:</Label>
            <Col sm={8}>
              <Input id="lastName" name="lastName" placeholder="Enter an Individual's last name" invalid={!!errors.lastname} onChange={(event)=>onLastnameChange(event)} />
              <FormFeedback>{errors.lastname}</FormFeedback>
            </Col>
          </FormGroup>
        </Col>
      </Row>
      <Row className="align-items-center">
        <Col md={6}>
          <FormGroup row>
            <Label for="email" sm={4}>Individual Email:</Label>
            <Col sm={8}>
              <Input id="email" name="email" placeholder="Enter an Individual email address" invalid={!!errors.email} onChange={(event)=>onEmailChange(event)} />
              <FormFeedback>{errors.email}</FormFeedback>
            </Col>
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col className="oms-row right-align-col">
          <Button type="submit" color="primary" disabled={!valid}>
            <SearchIcon /> Search
          </Button>
        </Col>
      </Row>
      {error && <Alert color="danger">Error searching orgs.</Alert>}
    </Form>

    </>
  )
});

export default SearchIndividualForm;
